import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Info as InfoIcon } from '@mui/icons-material';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import { Chip } from '@mui/material';
import { helpers } from "@simplybenefits/sb-utils";
import UsageBlock from './UsageBlock.js';

/**
 * 
 * @param {*} param0 
 * @returns
 */
const TextLine = ({ tooltipText, text }) => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Tooltip
                title={ tooltipText }
                arrow
                placement="top"
            >
                <InfoIcon aria-label="info" style={{ fontSize: 15, color: Theme.colors.mediumGrey, marginRight: 10 }} />
            </Tooltip>
            <Text small bold> { text } </Text>
        </div>
    </div>
);

/**
 *
 * @param {*} param0
 * @returns {*}
 * @constructor
 */
const DentalUsageBlock = ({ usage, coverage, fillColor, waivedDental }) => {
    const {
        isFamilyCombinedMaximum,
        familyCombinedAmountRemaining,
        combinedAmountRemaining,
        isCombinedMaximum,
        usageObject
    } = usage;

    return (
        <React.Fragment>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                <div>
                    <Text
                        medium
                        bold
                        customStyle={{
                            flex: 1,
                            display: 'inline',
                            margin: '0 0 10px 0'
                        }}
                    >
                        Dental
                    </Text>
                    {
                        waivedDental &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "5px 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </div>

                <div style={{ marginBottom: 5 }}>
                    {
                        isFamilyCombinedMaximum
                            ? (
                                <TextLine 
                                    tooltipText={`You and your family can spend up to a combined $${ helpers.numberWithCommasDecimals(familyCombinedAmountRemaining) } on any combination of Basic and Major Dental services. Orthodontic claims are not included in this family maximum.` }
                                    text={`Family Dental Remaining $${ helpers.numberWithCommasDecimals(familyCombinedAmountRemaining) } | $${ helpers.numberWithCommasDecimals(coverage.familyCombinedMaximum) } Maximum`}
                                />
                            )
                            : null
                    }
                    {
                        isCombinedMaximum
                            ? (
                                <TextLine 
                                    tooltipText={`You can spend up to $${ helpers.numberWithCommasDecimals(combinedAmountRemaining) } on any combination of Basic and Major Dental services.`}
                                    text={ `$${ helpers.numberWithCommasDecimals(combinedAmountRemaining) } Remaining | Basic & Major Combined Maximum $${ helpers.numberWithCommasDecimals(coverage.basicMajorCombinedMax) }`}
                                />
                            )
                            : null
                    }
                </div>
            </div>

            {
                Object.entries(usageObject).map(([ key, item ]) => (
                    item.showItem && (<UsageBlock
                        key={ key }
                        usage={{
                            type: item.title,
                            limit: item.limit,
                            used: item.used
                        }}
                        fillColor={ fillColor }
                        showRemaining={ true }
                    />)
                ))
            }
        </React.Fragment>
    );
};

export default DentalUsageBlock;